'use client'
import { Box } from '@mui/material'
import React from 'react'
import BrandLogo from '../brandLogo'

const MobileHeader: React.FC = () => {
    return (
        <Box
            sx={{
                width: '100%',
                bgcolor: 'background.primary',
                borderBottom: '1px solid',
                borderColor: 'grey.200',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                py: 2,
                height: 54
            }}
        >
            <Box
                sx={{
                    height: 26,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer'
                }}
                onClick={() => (window.location.href = '/')}
            >
                <BrandLogo />
            </Box>
        </Box>
    )
}

export { MobileHeader }
